export enum FilterType {
  SELECT = "SELECT",
  INPUT = "INPUT",
}

export const filterTypeList = [
  { value: FilterType.SELECT, label: "Select" },
  { value: FilterType.INPUT, label: "Input" },
];
